export enum GeneratedDocumentRecordSourceType {
  ProviderFacilityRetrieval = 'provider_facility_retrieval',
  MedicationsDigitalData = 'medications_digital_data',
  DigitalHealthDataHie = 'digital_health_data_hie',
}
